<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <CSidebarBrand>
      <div
        v-show="!sidebarUnfoldable"
        custom-class-name="sidebar-brand-full"
        style="padding-bottom: 15px"
      >
        <p style="margin-bottom: 10px">
          <img src="images/logo.svg" style="padding: 16px 0 3px" />
        </p>
        <span class="font-weight-bold font-xs">来店者分析システム</span>
        <br />
      </div>
      <div
        v-if="sidebarUnfoldable"
        custom-class-name="sidebar-brand-narrow"
        style="padding-bottom: 15px"
      >
        <p style="margin-bottom: 10px">
          <img src="images/icon_e.svg" style="padding: 16px 0 3px" />
        </p>
      </div>
      <!-- <CIcon
        custom-class-name="sidebar-brand-full"
        :icon="logoNegative"
        :height="35"
      />
      <CIcon
        custom-class-name="sidebar-brand-narrow"
        :icon="sygnet"
        :height="35"
      /> -->
    </CSidebarBrand>
    <AppSidebarNav />
    <CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('toggleUnfoldable')"
    />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import { logoNegative } from '@/assets/brand/logo-negative'
import { sygnet } from '@/assets/brand/sygnet'
// import { iconEnazeal } from '@/assets/brand/icon-enazeal'
// import { logoEnazeal } from '@/assets/brand/logo-enazeal'

export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  setup() {
    const store = useStore()
    return {
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
}
</script>
